import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TraductorService} from './servicios/traductor.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BarraComponent } from './componentes/barra/barra.component';
import { VideoComponent } from './componentes/video/video.component';
import { GaleriaComponent } from './componentes/galeria/galeria.component';
import { HomeComponent } from './componentes/home/home.component';
import { FooterComponent } from './componentes/footer/footer.component';
import { IdiomaHomeService } from './servicios/idiomas/idioma-home.service';


@NgModule({
  declarations: [
    AppComponent,
    BarraComponent,
    VideoComponent,
    GaleriaComponent,
    HomeComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule    
  ],
  providers: [
    TraductorService,
    IdiomaHomeService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
